export var BASE_THEME_IDS;

(function (BASE_THEME_IDS) {
  BASE_THEME_IDS["onboarding"] = "onboarding";
})(BASE_THEME_IDS || (BASE_THEME_IDS = {}));